import { 
    PropsWithChildren, 
    useContext
  } from 'react';
  import ReactJson from 'react-json-view-with-toggle';
  import { useParams } from 'react-router-dom';
  import { Paper } from '@mui/material';
  import BasicTabs from '../../components/BasicTabs';
  import LoadingWrapper from '../../components/LoadingWraper';
  import {useQuery} from "@tanstack/react-query";
  import { LabContext } from "../../context/lab";
import { fetchSnapshot } from '../../services';
import { ISnapshot } from '../../types/snapshot';
import SnapshotOverview from './components/SnapshotOverview';
import SnapshotAssetsView from './components/SnapshotAssetsView';
import SnapshotGroupsTab from './components/SnapshotGroupsTab';
import OmniAccount from './OmniAccount';
import CopyTxtIconBtn from '../../components/CopyTxtIconBtn';
import SearchResultTitle from '../../components/SearchResultTitle';
  
  function Wrapper({ children }: PropsWithChildren<{}>){
    return <Paper sx={{ p: '0.7rem 1rem' }}>{children}</Paper>
  }
  
  function SnapshotJsonView(snapshot: any){
    
    return (<>
        <Wrapper 
            children={
                <>
                    <CopyTxtIconBtn value={snapshot? JSON.stringify(snapshot): ""}  />
                    <ReactJson 
                        collapseStringsAfterLength={55}  
                        collapsed={true}
                        theme={'twilight'}  
                        data-testid="json" 
                        src={snapshot}
                    />
                </>
            }
        />
    </>);
  }
  
  export default function Snapshot(){
    const { address } = useParams();
    const {lab} = useContext(LabContext);
    
    const { isLoading, isSuccess ,data, error, isFetching,  } = useQuery(['snapshot', address],  async () => 
        await fetchSnapshot({nodeLab: lab!.nodeLab.toString(), address: address!}),{
            refetchOnWindowFocus: false, 
            retry: 3
        }
    );

    const snap: ISnapshot = {...data};
  
    return <>
        <SearchResultTitle
        > 
            Address: <CopyTxtIconBtn fontSize="small" value={address || ""}/> {address}
        </SearchResultTitle>
        
        <LoadingWrapper
            child={
                <BasicTabs children={[
                    {
                        label: 'Account',
                        content: <OmniAccount />,
                    },
                    {
                        label: 'Safe Overview',
                        content: <SnapshotOverview snapshot={snap} />,
                    },
                    {
                        label: 'Assets',
                        content: <SnapshotAssetsView snapshotAssets={snap.assets} />,
                    },
                    {
                        label: 'Groups',
                        content: <SnapshotGroupsTab groups={snap.groups} />,
                    },
                    {
                        label: 'Raw View',
                        content: SnapshotJsonView(data),
                    },
                ]}/>
            }
            isLoading = {isLoading || isFetching}
            error = {!!error}
            isSucceeded={isSuccess && Object.keys(data).length > 0}
        />
    </>
  }
  
  